import React from 'react';

import Button from '@material-ui/core/Button';
import Grid from '@material-ui/core/Grid';
import Box from '@material-ui/core/Box';


import ArrowBackIcon from '@material-ui/icons/ArrowBack';
import { createStyles, makeStyles } from '@material-ui/core/styles';

import FixedToolbar from 'components/FixedToolbar'
import MainContentLayout from 'layouts/MainContentLayout';

import { observer } from 'mobx-react'
import { useRouterStore } from 'mobx-state-router';
import { useRootStore } from 'contexts';


import ActionButtons from 'jimbo/ui/ActionButtons'


import NotificationForm from './components/NotificationForm';

const useStyles = makeStyles((theme) =>
	createStyles({
		offset: theme.mixins.toolbar,
		backToOverview: {
			backgroundColor: theme.palette.primary.light
		}
	})
);


const NotificationScreen = observer((props) => {

	const classes = useStyles();
    const routerStore = useRouterStore();
    const rootStore = useRootStore();
    const { notificationsStore } = rootStore;
	
	const notification = notificationsStore.selectedObject;

    const onBackToOverview = () => {
		routerStore.goTo("notifications")
	}

    const backButton =  <Button
		onClick={() => onBackToOverview() }
		size="small"
		variant="text">
		<ArrowBackIcon />
			Back to Overview
		</Button>

	const toolbar = <FixedToolbar back={backButton} >
		<div>
			{notification ? <ActionButtons store={notificationsStore} instance={notification} />: null}
		</div>
	</FixedToolbar>


	return (
		<MainContentLayout toolbar={toolbar}>
			{notification ?
			<Grid container>
				<Grid item xs={3}>
				</Grid>
				<Grid item xs={5}>
					<Box color="primary.main" bgcolor="background.paper" margin={1} padding={1}>
						<NotificationForm instance={notification} store={notificationsStore} />
					</Box>
				</Grid>
			</Grid>: null}

			<div className={classes.offset} />
		</MainContentLayout>)
});

export default NotificationScreen;

